module.exports = __webpack_public_path__ + "media/images/icons/filled/bell-48724b4bb48136c91300a2b8dde549af.svg";